import { render, staticRenderFns } from "./DataBarang.vue?vue&type=template&id=3c2b4e8a"
import script from "./DataBarang.vue?vue&type=script&lang=js"
export * from "./DataBarang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports